module.exports = __webpack_public_path__ + "img/interior_7.d1ae34b1.jpg";